import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

/**
 * The purpose of this service is to provide a subject that reflects "loading status" throughout the application.
 * It is used by the loader component to show/hide a loader whenever there are pending http requests. This same subject
 * can be used for other places in the application where a loader is to be shown.
 * Refer this https://firstclassjs.com/display-a-loader-on-every-http-request-using-interceptor-in-angular-7/.
 */

@Injectable({
  providedIn: 'root',
})
export class LoaderService {
  private _isLoading = new Subject<boolean>();

  isLoadingInProgress = false;

  /**
   * Getter to return an observable of private _isLoading subject.
   */
  get isLoading$() {
    return this._isLoading.asObservable();
  }

  /**
   * Method for show loader.
   *
   */
  show() {
    this._isLoading.next(true);
    this.isLoadingInProgress = true;
  }

  /**
   * Method for hide loader.
   *
   */
  hide() {
    this._isLoading.next(false);
    this.isLoadingInProgress = false;
  }
}
